import { Multiselect, Select } from '@amzn/awsui-components-react-v3';
import React from 'react';
import { PRODUCT_LINE_IDS_TO_RANK } from '../../constants/product_line';
import { AccuracyButtonNewStyle, ZERO_WIDTH_SPACE } from '../../styles/common_styles';
import { Asterisk } from './asterisk';
import { SelectedTokenLimits } from '../const/dropdown_elements'
import {
  findOptionsWithLabel,
  findOptionWithLabel
} from "../reports/utils/buttons";

export class ProductLinesButton extends React.Component {
  extractDropdownOptions = (productLines) => {
    let dropdownOptions = [];
    if (productLines) {
      this.convertProductLine(productLines, '', '', dropdownOptions);
    }
    return dropdownOptions;
  };

  convertProductLine = (productLine, prefix, description, accumulator) => {
    if (this.props.multiselect) {
      accumulator.push({
                         label: prefix + productLine['name'],
                         value: productLine['id'],
                         description,
                         disabled: !this.isPLValidForParent(productLine)
                       });
    } else {
      accumulator.push({
                         label: prefix + productLine.name,
                         value: productLine.id,
                         gls: this.getGlsFromProductLine(productLine),
                         disabled: !this.isPLValidForAsinMetric(productLine)
                       });
    }

    if (productLine['children']) {
      let children = productLine['children'].concat();
      children.sort((a, b) => this.sortProductLines(a, b));
      for (let child of children) {
        // The string being concatenated to prefix is not an empty string. It is a space with zero width. This is used to add hierarchy through css visually.
        this.convertProductLine(child, prefix + ZERO_WIDTH_SPACE, '', accumulator);
      }
    }
  };

  /**
   * Checks for if a PL should be enabled from dropdown for ASIN Metrics Report.
   * A valid PL satisfies the following conditions:
   * 1. Is not ignored
   * 2. Id != "-1" (reserved for Unmapped)
   * 3. Is a leaf product line and is mapped to gls other than -1 or is not a leaf PL, and has children PLs
   * @param productLine
   * @returns {boolean}
   */
  isPLValidForAsinMetric = (productLine) => {
    return !productLine.ignored && productLine.id !== "-1" && ((productLine.isLeaf && productLine.gls && productLine.gls.length > 0 && productLine.gls[0] !== -1)
      || (!productLine.isLeaf && productLine.children && productLine.children.length > 0));
  }

  isPLValidForParent = (productLine) => {
    const { productLineParentFilter } = this.props; 
    if (!productLineParentFilter || !productLineParentFilter.length)  {
      // No parent product line filter - all are valid
      return true;
    }
    return productLineParentFilter.includes((productLine || {}).parent) 
      || productLineParentFilter.includes((productLine || {}).id);
  }

  getGlsFromProductLine = (productLine) => {
    let gls = [];
    let queue = [productLine];
    while(queue.length !== 0) {
      const pl = queue.shift();
      const children = pl.children;
      if(children !== null && children !== undefined && children.length !== 0) {
        queue.push(...children);
      }
      if(pl.isLeaf && !pl.isExcluded && !pl.isIgnored){
        if(pl.gls && pl.gls.length > 0 && !pl.gls.includes(-1)) {
          gls.push(...pl.gls);
        }
      }
    }
    return [...new Set(gls)];
  }

  getRank = (item) => {
    return PRODUCT_LINE_IDS_TO_RANK[item] ? PRODUCT_LINE_IDS_TO_RANK[item] : Number.MAX_SAFE_INTEGER;
  }

  sortProductLines = (a, b) => {
    if (a.isLeaf && b.isLeaf) {
      return (a.name || '').localeCompare(b.name);
    }
    return this.getRank(a.id) - this.getRank(b.id);
  }

  render() {
    let options = this.extractDropdownOptions(this.props.productLines);
    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Asterisk required={this.props.required}/>
        { this.props.multiselect && (
          <Multiselect
            options={ options }
            filteringType="auto"
            placeholder={ this.props.text }
            onChange={ this.props.onChange }
            selectedOptions={findOptionsWithLabel(options, this.props.selected)}
            statusType={ !this.props.productLines ? 'loading' : 'finished' }
            loadingText="Loading product lines..."
            tokenLimit={this.props.tokenLimit || SelectedTokenLimits.PRODUCT_LINES || SelectedTokenLimits.DEFAULT}
            data-cy={ this.props['data-cy'] }
            disabled={this.props.disabled}
          />)
        }
        { !this.props.multiselect && (
          <Select
            options={ options }
            selectedOption={findOptionWithLabel(options, this.props.selected && this.props.selected.length > 0 ? this.props.selected[0] : '')}
            filteringType="auto"
            placeholder={this.props.text}
            onChange={this.props.onChange}
            statusType={!this.props.productLines ? 'loading' : 'finished'}
            loadingText="Loading product lines..."
            data-cy={this.props['data-cy']}
          />
        )}
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'product-lines-button'
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/product_lines_button.jsx